export const RATE_SORT_TYPE = {
  RADIO: 'radio',
  SELECT: 'select',
}

export const RATE_SORT_OPTIONS = {
  RELEVANCE: 'relevance',
  RECENT: 'recent_reviews',
  HIGHEST: 'rate_descending',
  LOWEST: 'rate_ascending',
}
